<template>
<Dialog :visible.sync="showDialog" :style="{ width: '900px' }" :header="headerPanelLocalProva()" :modal="true" @hide="hideDialog">

      <div v-if="localProva && localProva.id" class="p-fluid formgrid grid">
        <!-- <div class="field col-12 md:col-6">
          <label for="nome" class="font-bold">Escola</label>
          <InputText
            id="nome" v-model.lazy="localProva.nome"
            type="text" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-2">
          <label for="cep" class="font-bold">CEP</label>
          <InputText
            id="cep"
            v-model="localProva.endereco.cep"
            disabled="true"/>
        </div>
        <div class="field col-12 md:col-3">
          <label for="endereco" class="font-bold">Logradouro</label>
          <InputText
            id="endereco"
            v-model="localProva.endereco.logradouro"
            disabled="true"/>
        </div>
        <div class="field col-12 md:col-1">
          <label for="numero" class="font-bold">Nmero</label>
          <InputText
            id="numero"
            v-model="localProva.endereco.numero"
            disabled="true"
          />
        </div>
        <div class="field col-12 md:col-6">
          <label for="complemento" class="font-bold">Complemento</label>
          <InputText
            id="complemento"
            v-model="localProva.endereco.complemento"
            disabled="true"
          />
        </div>
        <div class="field col-12 md:col-6">
          <label for="bairro" class="font-bold">Bairro</label>
          <InputText
            id="bairro"
            v-model="localProva.endereco.bairro"
            disabled="true"
          />
        </div>

        <div class="field col-12 md:col-3">
          <label for="estado" class="font-bold">Estado</label>
          <InputText
            id="estado"
            v-model="localProva.endereco.cidade.estado.uf"
            disabled="true"
          />
        </div>

        <div class="field col-12 md:col-3">
          <label for="cidade" class="font-bold">Cidade</label>
          <InputText
            id="cidade"
            v-model="localProva.endereco.cidade.nome"
            disabled="true"
          />
        </div> -->

        <div class="col-12 md:col-12 p-0">
          <DataTable
            :value="localProva.andares"
            class="col-12 md:col-12 p-datatable-sm p-datatable-gridlines"
            :expandedRows.sync="expandedRows"
            dataKey="id"
            responsiveLayout="scroll"
          >
            <template #header>
              <div class="table-header">
                <h5>Estrutura da escola (andares e salas)</h5>
              </div>
            </template>

            <Column :expander="true" :headerStyle="{ width: '3rem' }" />

            <Column field="numero" header="Andar" />
            <Column field="qtSalas" header="Quantidade de Salas">
              <template #body="slotProps">
                {{ slotProps.data.salas.length }}
              </template>
            </Column>
            <Column field="qtSalas" header="Quantidade de Individuais">
              <template #body="slotProps">
                {{ slotProps.data.quantidadeSalasIndividuais }}
              </template>
            </Column>
            <template #expansion="slotProps">
              <div class="ml-6">
                <h5>Salas do andar: {{ slotProps.data.numero }}</h5>
                <DataTable :value="slotProps.data.salas">
                  <Column field="numero" header="Número" sortable></Column>
                  <Column field="qtLugares" header="Lugares" sortable></Column>
                  <Column header="Sala Individual">
                    <template #body="slotProps">
                      {{ slotProps.data.salaExtra ? "Sim" : "Não" }}
                    </template>
                  </Column>
                </DataTable>
              </div>
            </template>
          </DataTable>
        </div>

        <div class="field col-12 md:col-12 mt-4">
            <Button label="Alterar" @click="alterar()" style="width: 150px"/>
        </div>
      </div>

</Dialog>
</template>

<script>

import InscricaoService from '../../service/InscricaoService';

export default {
    components: {},
    props: {
        detalheEscolaDialog: null,
        editarDialog: null,
        localProva: null,
        processo: null,
    },
    data() {
        return {
            showDialog: false,
            expandedRows: [],
            habilitaInscricoes: false,
            inscricaoService: null,
            estadoInscricaoService: null,
            // teste
            distribuicaoConcluida: true,
            distribuicoes: [],
            selectedSala: null,
        };
    },
    created() {
        this.inscricaoService = new InscricaoService();
    },
    watch :{
      detalheEscolaDialog: function(val) {
        this.showDialog = val;
      },
      localProva(){
        this.distribuicoes = this.localProva.andares;
      }
    },
    methods: {
      hideDialog() {
        this.$emit('update:detalheEscolaDialog', false);
        this.showDialog = false;
        this.messagesCadastroLocal = [];
      },
      headerPanelLocalProva() {
        return "Escola: " + ( this.localProva ? this.localProva.nome : "" );
      },
      alterar(){
        this.$emit('update:detalheEscolaDialog', false);
        this.$emit('update:editarDialog', true);
      },
    },

};

</script>

<style>
</style>
